import React from "react";
import { Helmet } from "react-helmet";
import { PartnerBanner } from "../../blocks/partner-banner";
import { PartnerFeature } from "../../blocks/partner-feature";
import { PartnerForm } from "../../blocks/partner-form";
import { PartnerRight } from "../../blocks/partner-right";
import { PartnerSystem } from "../../blocks/partner-system";
import { Footer } from "../../components/FooterV2";
import { Header } from "../../components/Header";
import { Link } from "../../components/Link";
import { Notice } from "../../components/Notice";
import "./styles.less";

export const PartnerPage = () => {
  return (
    <div className="partner-page">
      <Helmet>
        <title>Authing合作伙伴体系-Authing身份云</title>
      </Helmet>
      <Header mode="dark" />
      <PartnerBanner />
      <PartnerFeature />
      <PartnerSystem />
      <PartnerRight />
      <PartnerForm />
      <Footer />
    </div>
  );
};
